import React from 'react'

export default function FindDoctor() {
  return (
    <div>FindDoctor</div>
  )
}
